import { render } from "./EventCard.vue?vue&type=template&id=f3b832c2&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=f3b832c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f3b832c2"

export default script